import { DEVICE_MODEL_TYPE } from "@tm/types";
import { getDeviceModelType } from "../../utils";

/**
 * Opens a URL in the device's default browser when inside a webview,
 * or in a new tab when on a regular browser.
 *
 * Webview: creates a `target="_blank"` anchor with `open=outside`
 * and clicks it programmatically. The native layer intercepts
 * `_blank` navigations and opens the URL externally.
 *
 * Browser: uses `window.open` with `_blank`.
 */
export const openExternalLink = (url: string): void => {
  if (!url) return;

  const normalised = url.startsWith("http") ? url : `https://${url}`;

  if (getDeviceModelType() === DEVICE_MODEL_TYPE.APP) {
    const separator = normalised.includes("?") ? "&" : "?";
    const link = document.createElement("a");
    link.href = `${normalised}${separator}open=outside`;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    window.open(normalised, "_blank", "noopener,noreferrer");
  }
};
